// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';

export default styled<any, Theme>('button')`
  &:focus {
    outline:0;
  }

  &::before {
    margin-right: 0.25rem;
    margin-bottom: 0.4375rem;
    font-size: 40px;
    line-height: 1.625rem;
  }

  width: 2.6875rem;
  height: 2.6875rem;
  opacity: 0.8;
  background-color: ${props => props.theme.slider.button.backgroundColor};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  color: ${props => props.theme.slider.button.chevronColor};
  border: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
`;
